<template>
    <div
        class="md-market-trends broker"
        :class="{ mobile: isMobileSize }"
        :style="{ marginBottom }"
        v-if="showThisModule"
    >
        <div class="container">
            <module-box noPadding noMargin>
                <!-- title -->
                <div class="title_container">
                    <div v-if="marketTitle" class="mg-title" v-html="formatFontSize(marketTitle, '--mg-title-size')"></div>
                    <div class="timeline">{{ timeline }}</div>
                </div>

                <div
                    class="filter-chart-container module_box"
                    v-show="!showNoData"
                >
                    <div class="trends-filter" v-if="!showLock">
                        <Select
                            class="sales-price"
                            :options="priceOptions"
                            :hide_name="true"
                            :value="priceType"
                            @change="changeFilterPrice"
                        ></Select>
                        <!-- Sold Number label -->
                        <div>
                            <span class="sold-number">{{
                                $t('md-market-trends.soldNumber')
                            }}</span>
                        </div>
                    </div>
                    <site-img
                        v-if="showLock"
                        alt="market trend sample"
                        src="https://cdn.chime.me/image/fs/sitebuild/2023526/0/original_229da156-cd26-4a55-949c-59b1e4f74ddd.png"
                    ></site-img>
                    <echart
                        v-if="!showLock"
                        :ref="onEchartRef"
                        class="chart-box"
                        :options="chartOption"
                        :notMerge="true"
                    >
                    </echart>
                    <div class="lock-container" v-if="showLock">
                        <div class="box">
                            <div class="lock-icon">
                                <span
                                    class="iconfont icon-circle-lock"
                                    @click="showRegisterPop"
                                ></span>
                            </div>
                            <div
                                class="avg-diff-text"
                                v-html="avgDiffText"
                            ></div>
                            <div class="desc" @click="showRegisterPop">
                                {{ TEXT.unlockDesc }}
                                <i class="iconfont icon-chevron_right"></i>
                            </div>
                        </div>
                    </div>
                    <p v-if="!showLock" class="mls-desc-tip">
                        <span class="iconfont icon-info-01"></span>
                        {{ TEXT.mlsDesc }}
                    </p>
                </div>
                <div class="no_data module_box" v-show="showNoData">
                    <img
                        class="pic"
                        src="//static.chimeroi.com/image/market-trends/blank-v3@2x.png"
                        :alt="$t('md-market-trends.noData')"
                    />
                    <div class="desc">{{ TEXT.noDataDesc }}</div>
                </div>
                <template v-if="cmpCheckMoreBtn || isInsight">
                    <div class="cta-btn" :class="{ disable: showNoData }">
                        <im-popper
                            :disabled="!showNoData"
                            :hover="true"
                            placement="top"
                            :offset="[0, 20]"
                            ref="tooltip"
                        >
                            <template v-slot:reference>
                                <button
                                    :style="checkMoreBtnStyle"
                                    v-html="
                                        isInsight
                                            ? defaultCheckMoreBtn
                                            : cmpCheckMoreBtn
                                    "
                                    @click="clickCheckMoreBtn"
                                ></button>
                            </template>
                        </im-popper>
                    </div>
                </template>
            </module-box>
        </div>
    </div>
</template>

<script>
import common from '../index';

export default {
    mixins: [common],
    data: function() {
        return {
            theme: 'broker'
        };
    },
    methods: {}
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
@import '.././chart.scss';
.md-market-trends.broker {
    .container {
        width: 100%;
        background-color: #fff;
        padding: 20px 0;
        @media (max-width: 600px) {
            padding: 20px 0;
        }
        .mg-container {
            overflow: unset;
        }
    }
    .title_container {
        padding-bottom: 30px;
        .mg-title {
            text-transform: uppercase;
            width: auto;
            margin: 0;
            padding-bottom: 3px;
            font-family: var(--mg-title-font);
            .zipcode {
                color: var(--color-label);
                font-size: 12px;
                padding-left: 10px;
            }
        }
        .timeline {
            color: #505050;
            font-size: 14px;
            font-family: var(--font-normal);
            margin-top: -3px;
        }
    }

    .filter-chart-container {
        position: relative;
        display: flex;
        flex-direction: column;
        > img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
        .trends-filter {
            height: 50px;
            color: var(--color-label);
            display: flex;
            justify-content: flex-end;
            > .select {
                position: relative;
                .box-div {
                    position: relative;
                    &:before {
                        content: '';
                        width: 12px;
                        height: 2px;
                        position: absolute;
                        top: 50%;
                        background: #17b124;
                        transform: translateY(-50%);
                        left: -22px;
                    }
                }
                .title {
                    width: 100%;
                    display: flex;
                    overflow: hidden;
                    cursor: pointer;
                    align-items: center;
                    .text {
                        flex: 1;
                        @include ellipsis();
                        cursor: pointer;
                        margin-right: 10px;
                    }
                    .icon-arrow-down {
                        flex: none;
                        color: #c6c8d1;
                    }
                }
                .list-panel {
                    // width: calc(100% + 24px);
                    position: absolute;
                    top: 100%;
                    left: -24px;
                    z-index: 10;
                    border-radius: 5px;
                    padding: 5px 0;
                    background: #fff;
                    margin-top: 5px;
                    box-shadow: 0 3px 10px 0 rgba(170, 186, 218, 0.3);
                    li {
                        white-space: nowrap;
                        padding: 0 20px;
                        line-height: 32px;
                        font-size: 14px;
                        color: #515666;
                        cursor: pointer;
                        &.selected {
                            color: var(--color-theme);
                            .iconfont.icon-checked-light {
                                display: none;
                            }
                        }
                        &:not(.selected):hover {
                            background-color: #f3f3f3;
                        }
                    }
                }
            }
            .sales-price {
                margin-right: 72px;
                .iconfont {
                    font-size: 12px;
                }
                .icon-arrow-down {
                    &::before {
                        content: '\e6cf';
                        color: #191919;
                    }
                }
            }
            .sold-number {
                position: relative;
                &:before {
                    content: '';
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    top: 50%;
                    background: #ff781d;
                    transform: translateY(-50%);
                    left: -22px;
                }
            }
        }
        .chart-box {
            width: 100%;
            z-index: var(--level-low);
            flex: 1;
            > div {
                z-index: 0;
            }
        }
        .lock-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: absolute;
            z-index: var(--level-low);
            top: 0;
            left: 0;
            -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
            background-color: rgba(255, 255, 255, 0.85);
            padding: 0 10px;
            .lock-icon {
                text-align: center;
                .icon-circle-lock {
                    cursor: pointer;
                    color: var(--color-theme);
                    font-size: 60px;
                }
            }
            .avg-diff-text {
                color: #8b93a7;
                font-size: 16px;
                margin: 20px 0;
                .number {
                    font-family: var(--font-bold);
                    &.up {
                        color: #29cb97;
                    }
                    &.down {
                        color: #ff5661;
                    }
                }
            }
            .desc {
                cursor: pointer;
                font-size: 16px;
                font-family: var(--font-bold);
                font-weight: 500;
                color: var(--color-theme);
                text-align: center;
            }
        }
    }
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .module_box {
        height: 470px;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
        box-shadow: 2px 2px 10px 0 rgba(0, 10, 30, 0.1);
        background-color: #ffffff;
        padding: 32px 60px 30px 60px;
    }
    .cta-btn {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        padding-top: 25px;
        &.disable {
            button {
                cursor: not-allowed;
            }
        }
        button {
            @include color-button-hover();
            font-size: 16px;
            font-family: var(--mg-button-font);
            font-weight: 500;
            padding-left: 30px;
            padding-right: 30px;
            padding-top: 10px;
            padding-bottom: 10px;
            min-height: 40px;
            min-width: 343px;
            text-align: center;
            border: 1px solid var(--cta-button-bgcolor, var(--color-theme));
            border-radius: 5px;
            color: var(--cta-button-color, var(--mg-button-color));
            background-color: var(
                --cta-button-bgcolor,
                var(--mg-button-background)
            );                
        }
        .im-popover {
            .popper {
                span {
                    background-color: #303133;
                    color: #fff;
                    padding: 6px 10px;
                    border-radius: 4px;
                    position: relative;
                    &::before {
                        position: absolute;
                        content: ' ';
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-style: solid;
                        bottom: -5px;
                        margin-left: 48%;
                        border-width: 5px;
                        border-top-color: #303133;
                        border-bottom-width: 0;
                    }
                }
            }
        }
    }
    .mls-desc-tip {
        position: relative;
        z-index: var(--level-low);
        color: #a8a8a8;
        margin-top: 20px;
        .iconfont {
            font-size: 14px;
            color: #a8a8a8;
            margin-right: 5px;
        }
    }
}
.md-market-trends.broker.mobile {
    .container {
        width: 100%;
        background-color: #fafafd;
    }
    .mg-title {
        padding-bottom: 5px;
        width: 100%;
        color: #191919;
    }
    .module_box {
        height: 370px;
        box-shadow: none;
        padding: 0;
    }
    .mls-desc-tip {
        margin-top: 10px;
    }
    .filter-chart-container {
        padding: 20px 10px;
        border-radius: 5px;
        box-shadow: 0 2px 20px 0 rgba(0, 10, 30, 0.05);
        background-color: #ffffff;
        .trends-filter {
            justify-content: flex-start;
            .box-div {
                margin-left: 20px;
                &:before {
                    left: -20px;
                    top: 7px;
                    transform: none;
                }
            }
            .title,
            .sold-number {
                font: 14px var(--font-normal);
                color: #191919;
            }
            .title {
                .text {
                    margin-right: 5px;
                }
                .dropdown_icon {
                    width: 12px;
                    font-size: 12px;
                }
            }
            .list-panel {
                width: auto;
                left: -20px;
                li {
                    padding: 0 10px 0 10px;
                }
            }
        }
        .sales-price {
            margin-right: 40px;
            .iconfont {
                font-size: 12px;
            }
            .icon-arrow-down {
                &::before {
                    content: '\e6cf';
                    color: #191919;
                }
            }
        }
    }

    .lock-container,
    .no_data {
        .avg-diff-text,
        .desc {
            font-size: 14px;
        }
    }
    .cta-btn {
        .im-popover {
            width: 100%;
        }
        button {
            width: 100%;
            min-width: auto;
        }
    }
}
</style>
